export default __webpack_public_path__ + "static/media/upload-light.b18c56f7.svg";